import styled from '@emotion/styled';
import { Modal } from '@mui/material';

import { USER_MEMBERSHIP_CARD_HEIGHT } from '../UserMembershipCard';

export const MembershipFullScreenModal = styled(Modal)`
  padding: 1.5rem;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;

  @media (orientation: portrait) {
    width: 100vh;
    width: 100dvh;
    height: 100vw;
    height: 100dvw;
    transform: rotate(90deg) translate(0%, -100%);
    transform-origin: top left;
  }

  .user-membership-card-container {
    --user-membership-width: 36rem;
    --user-membership-padding: 1rem;
    --user-membership-card-scale: 1.5;

    transform: scale(var(--user-membership-card-scale));

    @media (orientation: landscape) {
      --user-membership-card-scale: min(
        calc((100vw - var(--user-membership-padding)) / var(--user-membership-width)),
        calc((100vh - var(--user-membership-padding)) / ${USER_MEMBERSHIP_CARD_HEIGHT})
      );
    }

    @media (orientation: portrait) {
      // Use a formula to calculate the scale based on the viewport width and height
      --user-membership-card-scale: min(
        calc((100vh - var(--user-membership-padding)) / var(--user-membership-width)),
        calc((100vw - var(--user-membership-padding)) / ${USER_MEMBERSHIP_CARD_HEIGHT})
      );
    }
  }
`;
